/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkExperience } from '../../models/work-experience';

export interface UpdateWorkExperience$Params {
  profileId: string;
  id: string;
      body?: WorkExperience
}

export function updateWorkExperience(http: HttpClient, rootUrl: string, params: UpdateWorkExperience$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkExperience>> {
  const rb = new RequestBuilder(rootUrl, updateWorkExperience.PATH, 'put');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkExperience>;
    })
  );
}

updateWorkExperience.PATH = '/studentprofile/{profileId}/workexperience/{id}';
